(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'jquery', 'kvision-js-legacy', 'snabbdom', 'kvision-kvision-jquery-js-legacy', 'kvision-kvision-common-types-js-legacy', 'kotlinx-coroutines-core'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('jquery'), require('kvision-js-legacy'), require('snabbdom'), require('kvision-kvision-jquery-js-legacy'), require('kvision-kvision-common-types-js-legacy'), require('kotlinx-coroutines-core'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-upload-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-bootstrap-upload-js-legacy'.");
    }if (typeof jQuery === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-upload-js-legacy'. Its dependency 'jquery' was not found. Please, check whether 'jquery' is loaded prior to 'kvision-kvision-bootstrap-upload-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-upload-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-bootstrap-upload-js-legacy'.");
    }if (typeof snabbdom === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-upload-js-legacy'. Its dependency 'snabbdom' was not found. Please, check whether 'snabbdom' is loaded prior to 'kvision-kvision-bootstrap-upload-js-legacy'.");
    }if (typeof this['kvision-kvision-jquery-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-upload-js-legacy'. Its dependency 'kvision-kvision-jquery-js-legacy' was not found. Please, check whether 'kvision-kvision-jquery-js-legacy' is loaded prior to 'kvision-kvision-bootstrap-upload-js-legacy'.");
    }if (typeof this['kvision-kvision-common-types-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-upload-js-legacy'. Its dependency 'kvision-kvision-common-types-js-legacy' was not found. Please, check whether 'kvision-kvision-common-types-js-legacy' is loaded prior to 'kvision-kvision-bootstrap-upload-js-legacy'.");
    }if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-upload-js-legacy'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'kvision-kvision-bootstrap-upload-js-legacy'.");
    }root['kvision-kvision-bootstrap-upload-js-legacy'] = factory(typeof this['kvision-kvision-bootstrap-upload-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-bootstrap-upload-js-legacy'], kotlin, jQuery, this['kvision-js-legacy'], snabbdom, this['kvision-kvision-jquery-js-legacy'], this['kvision-kvision-common-types-js-legacy'], this['kotlinx-coroutines-core']);
  }
}(this, function (_, Kotlin, $module$jquery, $module$kvision_js_legacy, $module$snabbdom, $module$kvision_kvision_jquery_js_legacy, $module$kvision_kvision_common_types_js_legacy, $module$kotlinx_coroutines_core) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var ModuleInitializer = $module$kvision_js_legacy.io.kvision.ModuleInitializer;
  var SimplePanel = $module$kvision_js_legacy.io.kvision.panel.SimplePanel;
  var FieldLabel = $module$kvision_js_legacy.io.kvision.form.FieldLabel;
  var InvalidFeedback = $module$kvision_js_legacy.io.kvision.form.InvalidFeedback;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var KFilesFormControl = $module$kvision_js_legacy.io.kvision.form.KFilesFormControl;
  var MutableState = $module$kvision_js_legacy.io.kvision.state.MutableState;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  var Unit = Kotlin.kotlin.Unit;
  var PropertyMetadata = Kotlin.PropertyMetadata;
  var h = $module$snabbdom.h;
  var Widget = $module$kvision_js_legacy.io.kvision.core.Widget;
  var getElementJQueryD = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.getElementJQueryD_tqt9mm$;
  var getElementJQuery = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.getElementJQuery_tqt9mm$;
  var bindAllJQueryListeners = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.bindAllJQueryListeners_yw480n$;
  var removeAllJQueryListeners = $module$kvision_kvision_jquery_js_legacy.io.kvision.core.removeAllJQueryListeners_yw480n$;
  var iterator = Kotlin.kotlin.js.iterator_s8jyvk$;
  var throwCCE = Kotlin.throwCCE;
  var numberToInt = Kotlin.numberToInt;
  var KFile = $module$kvision_kvision_common_types_js_legacy.io.kvision.types.KFile;
  var joinToString = Kotlin.kotlin.collections.joinToString_fmv235$;
  var i18n = $module$kvision_js_legacy.io.kvision.i18n;
  var GenericFormComponent = $module$kvision_js_legacy.io.kvision.form.GenericFormComponent;
  var FormInput = $module$kvision_js_legacy.io.kvision.form.FormInput;
  var COROUTINE_SUSPENDED = Kotlin.kotlin.coroutines.intrinsics.COROUTINE_SUSPENDED;
  var CoroutineImpl = Kotlin.kotlin.coroutines.CoroutineImpl;
  var Widget$Widget$RefreshDelegateProvider_init = $module$kvision_js_legacy.io.kvision.core.Widget.RefreshDelegateProvider;
  var LinkedHashMap_init = Kotlin.kotlin.collections.LinkedHashMap_init_q3lmfv$;
  var copyToArray = Kotlin.kotlin.collections.copyToArray;
  var Object_init = Object;
  var Exception_init = Kotlin.kotlin.Exception_init_pdl1vj$;
  var withDefault = Kotlin.kotlin.collections.withDefault_jgsead$;
  var IllegalStateException_init = Kotlin.kotlin.IllegalStateException_init_pdl1vj$;
  var Result = Kotlin.kotlin.Result;
  var createFailure = Kotlin.kotlin.createFailure_tcv7n7$;
  var intercepted = Kotlin.kotlin.coroutines.intrinsics.intercepted_f9mg25$;
  var CancellableContinuationImpl_init = $module$kotlinx_coroutines_core.kotlinx.coroutines.CancellableContinuationImpl;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init_0 = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var mapCapacity = Kotlin.kotlin.collections.mapCapacity_za3lpa$;
  var coerceAtLeast = Kotlin.kotlin.ranges.coerceAtLeast_dqglrj$;
  var LinkedHashMap_init_0 = Kotlin.kotlin.collections.LinkedHashMap_init_bwtc7$;
  Upload.prototype = Object.create(SimplePanel.prototype);
  Upload.prototype.constructor = Upload;
  UploadInput.prototype = Object.create(Widget.prototype);
  UploadInput.prototype.constructor = UploadInput;
  function BootstrapUploadModule() {
    BootstrapUploadModule_instance = this;
    var bootstrap = require('bootstrap');
    $module$jquery.fn['modal'] = bootstrap.Modal.jQueryInterface;
    $module$jquery.fn['modal'].Constructor = bootstrap.Modal;
  }
  BootstrapUploadModule.prototype.initialize = function () {
    require('bootstrap-fileinput/css/fileinput.min.css');
    require('bootstrap-fileinput/themes/explorer-fa6/theme.min.css');
    require('bootstrap-fileinput');
    require('kvision-assets/js/locales/bootstrap-fileinput/ar.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/az.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/bg.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/ca.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/cr.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/cs.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/da.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/de.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/el.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/es.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/et.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/fa.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/fi.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/fr.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/gl.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/he.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/hu.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/id.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/it.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/ja.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/ka.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/kr.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/kz.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/lt.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/lv.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/nl.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/no.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/pl.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/pt.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/ro.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/ru.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/sk.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/sl.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/sr-latn.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/sv.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/th.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/tr.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/uk.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/uz.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/vi.js');
    require('kvision-assets/js/locales/bootstrap-fileinput/zh.js');
    require('bootstrap-fileinput/themes/explorer-fa6/theme.js');
    require('bootstrap-fileinput/themes/fa6/theme.js');
  };
  BootstrapUploadModule.$metadata$ = {kind: Kind_OBJECT, simpleName: 'BootstrapUploadModule', interfaces: [ModuleInitializer]};
  var BootstrapUploadModule_instance = null;
  function BootstrapUploadModule_getInstance() {
    if (BootstrapUploadModule_instance === null) {
      new BootstrapUploadModule();
    }return BootstrapUploadModule_instance;
  }
  function Upload(uploadUrl, multiple, label, rich, init) {
    Upload$Companion_getInstance();
    if (uploadUrl === void 0)
      uploadUrl = null;
    if (multiple === void 0)
      multiple = false;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, 'form-group kv-mb-3');
    this.observers = ArrayList_init();
    this.idc = 'kv_form_upload_' + Upload$Companion_getInstance().counter_8be2vx$;
    var $receiver = new UploadInput(uploadUrl, multiple);
    $receiver.id = this.idc;
    $receiver.name = $receiver.name;
    this.input_xexdl5$_0 = $receiver;
    this.flabel_flxakb$_0 = new FieldLabel(this.idc, label, rich, 'form-label');
    var $receiver_0 = new InvalidFeedback();
    $receiver_0.visible = false;
    this.invalidFeedback_hgfknv$_0 = $receiver_0;
    var tmp$;
    this.input.eventTarget = this;
    this.addPrivate_87eobz$(this.flabel);
    this.addPrivate_87eobz$(this.input);
    this.addPrivate_87eobz$(this.invalidFeedback);
    tmp$ = Upload$Companion_getInstance().counter_8be2vx$;
    Upload$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0;
    init != null ? init(this) : null;
  }
  Object.defineProperty(Upload.prototype, 'value', {configurable: true, get: function () {
    return this.input.value;
  }, set: function (value) {
    this.input.value = value;
  }});
  Object.defineProperty(Upload.prototype, 'uploadUrl', {configurable: true, get: function () {
    return this.input.uploadUrl;
  }, set: function (value) {
    this.input.uploadUrl = value;
  }});
  Object.defineProperty(Upload.prototype, 'multiple', {configurable: true, get: function () {
    return this.input.multiple;
  }, set: function (value) {
    this.input.multiple = value;
  }});
  Object.defineProperty(Upload.prototype, 'uploadExtraData', {configurable: true, get: function () {
    return this.input.uploadExtraData;
  }, set: function (value) {
    this.input.uploadExtraData = value;
  }});
  Object.defineProperty(Upload.prototype, 'explorerTheme', {configurable: true, get: function () {
    return this.input.explorerTheme;
  }, set: function (value) {
    this.input.explorerTheme = value;
  }});
  Object.defineProperty(Upload.prototype, 'required', {configurable: true, get: function () {
    return this.input.required;
  }, set: function (value) {
    this.input.required = value;
  }});
  Object.defineProperty(Upload.prototype, 'showCaption', {configurable: true, get: function () {
    return this.input.showCaption;
  }, set: function (value) {
    this.input.showCaption = value;
  }});
  Object.defineProperty(Upload.prototype, 'showPreview', {configurable: true, get: function () {
    return this.input.showPreview;
  }, set: function (value) {
    this.input.showPreview = value;
  }});
  Object.defineProperty(Upload.prototype, 'showRemove', {configurable: true, get: function () {
    return this.input.showRemove;
  }, set: function (value) {
    this.input.showRemove = value;
  }});
  Object.defineProperty(Upload.prototype, 'showUpload', {configurable: true, get: function () {
    return this.input.showUpload;
  }, set: function (value) {
    this.input.showUpload = value;
  }});
  Object.defineProperty(Upload.prototype, 'showCancel', {configurable: true, get: function () {
    return this.input.showCancel;
  }, set: function (value) {
    this.input.showCancel = value;
  }});
  Object.defineProperty(Upload.prototype, 'showBrowse', {configurable: true, get: function () {
    return this.input.showBrowse;
  }, set: function (value) {
    this.input.showBrowse = value;
  }});
  Object.defineProperty(Upload.prototype, 'browseOnZoneClick', {configurable: true, get: function () {
    return this.input.browseOnZoneClick;
  }, set: function (value) {
    this.input.browseOnZoneClick = value;
  }});
  Object.defineProperty(Upload.prototype, 'preferIconicPreview', {configurable: true, get: function () {
    return this.input.preferIconicPreview;
  }, set: function (value) {
    this.input.preferIconicPreview = value;
  }});
  Object.defineProperty(Upload.prototype, 'allowedFileTypes', {configurable: true, get: function () {
    return this.input.allowedFileTypes;
  }, set: function (value) {
    this.input.allowedFileTypes = value;
  }});
  Object.defineProperty(Upload.prototype, 'allowedFileExtensions', {configurable: true, get: function () {
    return this.input.allowedFileExtensions;
  }, set: function (value) {
    this.input.allowedFileExtensions = value;
  }});
  Object.defineProperty(Upload.prototype, 'dropZoneEnabled', {configurable: true, get: function () {
    return this.input.dropZoneEnabled;
  }, set: function (value) {
    this.input.dropZoneEnabled = value;
  }});
  Object.defineProperty(Upload.prototype, 'placeholder', {configurable: true, get: function () {
    return this.input.placeholder;
  }, set: function (value) {
    this.input.placeholder = value;
  }});
  Object.defineProperty(Upload.prototype, 'label', {configurable: true, get: function () {
    return this.flabel.content;
  }, set: function (value) {
    this.flabel.content = value;
  }});
  Object.defineProperty(Upload.prototype, 'rich', {configurable: true, get: function () {
    return this.flabel.rich;
  }, set: function (value) {
    this.flabel.rich = value;
  }});
  Object.defineProperty(Upload.prototype, 'input', {configurable: true, get: function () {
    return this.input_xexdl5$_0;
  }});
  Object.defineProperty(Upload.prototype, 'flabel', {configurable: true, get: function () {
    return this.flabel_flxakb$_0;
  }});
  Object.defineProperty(Upload.prototype, 'invalidFeedback', {configurable: true, get: function () {
    return this.invalidFeedback_hgfknv$_0;
  }});
  Upload.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.validatorError != null) {
      classSetBuilder.add_61zpoe$('text-danger');
    }};
  Upload.prototype.setEventListener_a1up2z$ = function (block) {
    return this.input.setEventListener_a1up2z$(block);
  };
  Upload.prototype.removeEventListener_za3lpa$ = function (id) {
    this.input.removeEventListener_za3lpa$(id);
    return this;
  };
  Upload.prototype.removeEventListeners = function () {
    this.input.removeEventListeners();
    return this;
  };
  Upload.prototype.getValueAsString = function () {
    return this.input.getValueAsString();
  };
  Upload.prototype.getNativeFile_ghgd4h$ = function (kFile) {
    return this.input.getNativeFile_ghgd4h$(kFile);
  };
  Upload.prototype.resetInput = function () {
    this.input.resetInput();
  };
  Upload.prototype.clearInput = function () {
    this.input.clearInput();
  };
  Upload.prototype.upload = function () {
    this.input.upload();
  };
  Upload.prototype.cancel = function () {
    this.input.cancel();
  };
  Upload.prototype.lock = function () {
    this.input.lock();
  };
  Upload.prototype.unlock = function () {
    this.input.unlock();
  };
  Upload.prototype.focus = function () {
    this.input.focus();
  };
  Upload.prototype.blur = function () {
    this.input.blur();
  };
  Upload.prototype.getState = function () {
    return this.input.getState();
  };
  Upload.prototype.subscribe_qlkmfe$ = function (observer) {
    return this.input.subscribe_qlkmfe$(observer);
  };
  Upload.prototype.setState_11rb$ = function (state) {
    this.input.setState_11rb$(state);
  };
  function Upload$Companion() {
    Upload$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  Upload$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Upload$Companion_instance = null;
  function Upload$Companion_getInstance() {
    if (Upload$Companion_instance === null) {
      new Upload$Companion();
    }return Upload$Companion_instance;
  }
  Upload.$metadata$ = {kind: Kind_CLASS, simpleName: 'Upload', interfaces: [MutableState, KFilesFormControl, SimplePanel]};
  function Widget$refreshOnUpdate$lambda_0(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function UploadInput(uploadUrl, multiple, className, init) {
    UploadInput$Companion_getInstance();
    if (uploadUrl === void 0)
      uploadUrl = null;
    if (multiple === void 0)
      multiple = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    Widget.call(this, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'form-control');
    this.observers = ArrayList_init();
    this.tmpValue = null;
    this.uploadUrl_rif3ah$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, uploadUrl, UploadInput$uploadUrl$lambda(this))).provideDelegate_n5byny$(this, UploadInput$uploadUrl_metadata);
    this.multiple_mtw1of$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, multiple, UploadInput$multiple$lambda(this))).provideDelegate_n5byny$(this, UploadInput$multiple_metadata);
    this.uploadExtraData_662hzg$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, UploadInput$uploadExtraData$lambda(this))).provideDelegate_n5byny$(this, UploadInput$uploadExtraData_metadata);
    this.explorerTheme_27gf45$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, UploadInput$explorerTheme$lambda(this))).provideDelegate_n5byny$(this, UploadInput$explorerTheme_metadata);
    this.required_gpt35c$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, UploadInput$required$lambda(this))).provideDelegate_n5byny$(this, UploadInput$required_metadata);
    this.showCaption_33uds4$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, UploadInput$showCaption$lambda(this))).provideDelegate_n5byny$(this, UploadInput$showCaption_metadata);
    this.showPreview_ncecbq$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, UploadInput$showPreview$lambda(this))).provideDelegate_n5byny$(this, UploadInput$showPreview_metadata);
    this.showRemove_6iyu1a$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, UploadInput$showRemove$lambda(this))).provideDelegate_n5byny$(this, UploadInput$showRemove_metadata);
    this.showUpload_fa0r4f$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, UploadInput$showUpload$lambda(this))).provideDelegate_n5byny$(this, UploadInput$showUpload_metadata);
    this.showCancel_2fhync$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, UploadInput$showCancel$lambda(this))).provideDelegate_n5byny$(this, UploadInput$showCancel_metadata);
    this.showBrowse_917tmg$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, UploadInput$showBrowse$lambda(this))).provideDelegate_n5byny$(this, UploadInput$showBrowse_metadata);
    this.browseOnZoneClick_t0zn7y$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, UploadInput$browseOnZoneClick$lambda(this))).provideDelegate_n5byny$(this, UploadInput$browseOnZoneClick_metadata);
    this.preferIconicPreview_epmrvk$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, UploadInput$preferIconicPreview$lambda(this))).provideDelegate_n5byny$(this, UploadInput$preferIconicPreview_metadata);
    this.allowedFileTypes_b44bqe$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, UploadInput$allowedFileTypes$lambda(this))).provideDelegate_n5byny$(this, UploadInput$allowedFileTypes_metadata);
    this.allowedFileExtensions_fd9g1f$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, UploadInput$allowedFileExtensions$lambda(this))).provideDelegate_n5byny$(this, UploadInput$allowedFileExtensions_metadata);
    this.dropZoneEnabled_dxvs75$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, UploadInput$dropZoneEnabled$lambda(this))).provideDelegate_n5byny$(this, UploadInput$dropZoneEnabled_metadata);
    this.hideThumbnailContent_x6gfa8$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, UploadInput$hideThumbnailContent$lambda(this))).provideDelegate_n5byny$(this, UploadInput$hideThumbnailContent_metadata);
    this.showUploadStats_vr616k$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, UploadInput$showUploadStats$lambda(this))).provideDelegate_n5byny$(this, UploadInput$showUploadStats_metadata);
    this.uploadAsync_on1n86$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, true, UploadInput$uploadAsync$lambda(this))).provideDelegate_n5byny$(this, UploadInput$uploadAsync_metadata);
    this.maxFileSize_xomrss$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, UploadInput$maxFileSize$lambda(this))).provideDelegate_n5byny$(this, UploadInput$maxFileSize_metadata);
    this.minFileSize_pu66ay$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, UploadInput$minFileSize$lambda(this))).provideDelegate_n5byny$(this, UploadInput$minFileSize_metadata);
    this.ajaxSettings_wt1ouk$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, UploadInput$ajaxSettings$lambda(this))).provideDelegate_n5byny$(this, UploadInput$ajaxSettings_metadata);
    this.placeholder_yedf3m$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, UploadInput$placeholder$lambda(this))).provideDelegate_n5byny$(this, UploadInput$placeholder_metadata);
    this.name_vbbspo$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, UploadInput$name_metadata);
    this.disabled_vepl65$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, false, UploadInput$disabled$lambda(this))).provideDelegate_n5byny$(this, UploadInput$disabled_metadata);
    this.size_v8fg7m$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, UploadInput$size_metadata);
    this.validationStatus_9cr31g$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, null, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, UploadInput$validationStatus_metadata);
    this.nativeFiles_ptdivv$_0 = LinkedHashMap_init();
    this.useSnabbdomDistinctKey();
    init != null ? init(this) : null;
  }
  Object.defineProperty(UploadInput.prototype, 'value', {configurable: true, get: function () {
    return this.getValue_dtueoc$_0();
  }, set: function (value) {
    if (value == null)
      this.resetInput();
    this.tmpValue = value;
    var tmp$;
    tmp$ = this.observers.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element(value);
    }
  }});
  var UploadInput$uploadUrl_metadata = new PropertyMetadata('uploadUrl');
  Object.defineProperty(UploadInput.prototype, 'uploadUrl', {configurable: true, get: function () {
    return this.uploadUrl_rif3ah$_0.getValue_fmbzy8$(this, UploadInput$uploadUrl_metadata);
  }, set: function (uploadUrl) {
    this.uploadUrl_rif3ah$_0.setValue_19qrsr$(this, UploadInput$uploadUrl_metadata, uploadUrl);
  }});
  var UploadInput$multiple_metadata = new PropertyMetadata('multiple');
  Object.defineProperty(UploadInput.prototype, 'multiple', {configurable: true, get: function () {
    return this.multiple_mtw1of$_0.getValue_fmbzy8$(this, UploadInput$multiple_metadata);
  }, set: function (multiple) {
    this.multiple_mtw1of$_0.setValue_19qrsr$(this, UploadInput$multiple_metadata, multiple);
  }});
  var UploadInput$uploadExtraData_metadata = new PropertyMetadata('uploadExtraData');
  Object.defineProperty(UploadInput.prototype, 'uploadExtraData', {configurable: true, get: function () {
    return this.uploadExtraData_662hzg$_0.getValue_fmbzy8$(this, UploadInput$uploadExtraData_metadata);
  }, set: function (uploadExtraData) {
    this.uploadExtraData_662hzg$_0.setValue_19qrsr$(this, UploadInput$uploadExtraData_metadata, uploadExtraData);
  }});
  var UploadInput$explorerTheme_metadata = new PropertyMetadata('explorerTheme');
  Object.defineProperty(UploadInput.prototype, 'explorerTheme', {configurable: true, get: function () {
    return this.explorerTheme_27gf45$_0.getValue_fmbzy8$(this, UploadInput$explorerTheme_metadata);
  }, set: function (explorerTheme) {
    this.explorerTheme_27gf45$_0.setValue_19qrsr$(this, UploadInput$explorerTheme_metadata, explorerTheme);
  }});
  var UploadInput$required_metadata = new PropertyMetadata('required');
  Object.defineProperty(UploadInput.prototype, 'required', {configurable: true, get: function () {
    return this.required_gpt35c$_0.getValue_fmbzy8$(this, UploadInput$required_metadata);
  }, set: function (required) {
    this.required_gpt35c$_0.setValue_19qrsr$(this, UploadInput$required_metadata, required);
  }});
  var UploadInput$showCaption_metadata = new PropertyMetadata('showCaption');
  Object.defineProperty(UploadInput.prototype, 'showCaption', {configurable: true, get: function () {
    return this.showCaption_33uds4$_0.getValue_fmbzy8$(this, UploadInput$showCaption_metadata);
  }, set: function (showCaption) {
    this.showCaption_33uds4$_0.setValue_19qrsr$(this, UploadInput$showCaption_metadata, showCaption);
  }});
  var UploadInput$showPreview_metadata = new PropertyMetadata('showPreview');
  Object.defineProperty(UploadInput.prototype, 'showPreview', {configurable: true, get: function () {
    return this.showPreview_ncecbq$_0.getValue_fmbzy8$(this, UploadInput$showPreview_metadata);
  }, set: function (showPreview) {
    this.showPreview_ncecbq$_0.setValue_19qrsr$(this, UploadInput$showPreview_metadata, showPreview);
  }});
  var UploadInput$showRemove_metadata = new PropertyMetadata('showRemove');
  Object.defineProperty(UploadInput.prototype, 'showRemove', {configurable: true, get: function () {
    return this.showRemove_6iyu1a$_0.getValue_fmbzy8$(this, UploadInput$showRemove_metadata);
  }, set: function (showRemove) {
    this.showRemove_6iyu1a$_0.setValue_19qrsr$(this, UploadInput$showRemove_metadata, showRemove);
  }});
  var UploadInput$showUpload_metadata = new PropertyMetadata('showUpload');
  Object.defineProperty(UploadInput.prototype, 'showUpload', {configurable: true, get: function () {
    return this.showUpload_fa0r4f$_0.getValue_fmbzy8$(this, UploadInput$showUpload_metadata);
  }, set: function (showUpload) {
    this.showUpload_fa0r4f$_0.setValue_19qrsr$(this, UploadInput$showUpload_metadata, showUpload);
  }});
  var UploadInput$showCancel_metadata = new PropertyMetadata('showCancel');
  Object.defineProperty(UploadInput.prototype, 'showCancel', {configurable: true, get: function () {
    return this.showCancel_2fhync$_0.getValue_fmbzy8$(this, UploadInput$showCancel_metadata);
  }, set: function (showCancel) {
    this.showCancel_2fhync$_0.setValue_19qrsr$(this, UploadInput$showCancel_metadata, showCancel);
  }});
  var UploadInput$showBrowse_metadata = new PropertyMetadata('showBrowse');
  Object.defineProperty(UploadInput.prototype, 'showBrowse', {configurable: true, get: function () {
    return this.showBrowse_917tmg$_0.getValue_fmbzy8$(this, UploadInput$showBrowse_metadata);
  }, set: function (showBrowse) {
    this.showBrowse_917tmg$_0.setValue_19qrsr$(this, UploadInput$showBrowse_metadata, showBrowse);
  }});
  var UploadInput$browseOnZoneClick_metadata = new PropertyMetadata('browseOnZoneClick');
  Object.defineProperty(UploadInput.prototype, 'browseOnZoneClick', {configurable: true, get: function () {
    return this.browseOnZoneClick_t0zn7y$_0.getValue_fmbzy8$(this, UploadInput$browseOnZoneClick_metadata);
  }, set: function (browseOnZoneClick) {
    this.browseOnZoneClick_t0zn7y$_0.setValue_19qrsr$(this, UploadInput$browseOnZoneClick_metadata, browseOnZoneClick);
  }});
  var UploadInput$preferIconicPreview_metadata = new PropertyMetadata('preferIconicPreview');
  Object.defineProperty(UploadInput.prototype, 'preferIconicPreview', {configurable: true, get: function () {
    return this.preferIconicPreview_epmrvk$_0.getValue_fmbzy8$(this, UploadInput$preferIconicPreview_metadata);
  }, set: function (preferIconicPreview) {
    this.preferIconicPreview_epmrvk$_0.setValue_19qrsr$(this, UploadInput$preferIconicPreview_metadata, preferIconicPreview);
  }});
  var UploadInput$allowedFileTypes_metadata = new PropertyMetadata('allowedFileTypes');
  Object.defineProperty(UploadInput.prototype, 'allowedFileTypes', {configurable: true, get: function () {
    return this.allowedFileTypes_b44bqe$_0.getValue_fmbzy8$(this, UploadInput$allowedFileTypes_metadata);
  }, set: function (allowedFileTypes) {
    this.allowedFileTypes_b44bqe$_0.setValue_19qrsr$(this, UploadInput$allowedFileTypes_metadata, allowedFileTypes);
  }});
  var UploadInput$allowedFileExtensions_metadata = new PropertyMetadata('allowedFileExtensions');
  Object.defineProperty(UploadInput.prototype, 'allowedFileExtensions', {configurable: true, get: function () {
    return this.allowedFileExtensions_fd9g1f$_0.getValue_fmbzy8$(this, UploadInput$allowedFileExtensions_metadata);
  }, set: function (allowedFileExtensions) {
    this.allowedFileExtensions_fd9g1f$_0.setValue_19qrsr$(this, UploadInput$allowedFileExtensions_metadata, allowedFileExtensions);
  }});
  var UploadInput$dropZoneEnabled_metadata = new PropertyMetadata('dropZoneEnabled');
  Object.defineProperty(UploadInput.prototype, 'dropZoneEnabled', {configurable: true, get: function () {
    return this.dropZoneEnabled_dxvs75$_0.getValue_fmbzy8$(this, UploadInput$dropZoneEnabled_metadata);
  }, set: function (dropZoneEnabled) {
    this.dropZoneEnabled_dxvs75$_0.setValue_19qrsr$(this, UploadInput$dropZoneEnabled_metadata, dropZoneEnabled);
  }});
  var UploadInput$hideThumbnailContent_metadata = new PropertyMetadata('hideThumbnailContent');
  Object.defineProperty(UploadInput.prototype, 'hideThumbnailContent', {configurable: true, get: function () {
    return this.hideThumbnailContent_x6gfa8$_0.getValue_fmbzy8$(this, UploadInput$hideThumbnailContent_metadata);
  }, set: function (hideThumbnailContent) {
    this.hideThumbnailContent_x6gfa8$_0.setValue_19qrsr$(this, UploadInput$hideThumbnailContent_metadata, hideThumbnailContent);
  }});
  var UploadInput$showUploadStats_metadata = new PropertyMetadata('showUploadStats');
  Object.defineProperty(UploadInput.prototype, 'showUploadStats', {configurable: true, get: function () {
    return this.showUploadStats_vr616k$_0.getValue_fmbzy8$(this, UploadInput$showUploadStats_metadata);
  }, set: function (showUploadStats) {
    this.showUploadStats_vr616k$_0.setValue_19qrsr$(this, UploadInput$showUploadStats_metadata, showUploadStats);
  }});
  var UploadInput$uploadAsync_metadata = new PropertyMetadata('uploadAsync');
  Object.defineProperty(UploadInput.prototype, 'uploadAsync', {configurable: true, get: function () {
    return this.uploadAsync_on1n86$_0.getValue_fmbzy8$(this, UploadInput$uploadAsync_metadata);
  }, set: function (uploadAsync) {
    this.uploadAsync_on1n86$_0.setValue_19qrsr$(this, UploadInput$uploadAsync_metadata, uploadAsync);
  }});
  var UploadInput$maxFileSize_metadata = new PropertyMetadata('maxFileSize');
  Object.defineProperty(UploadInput.prototype, 'maxFileSize', {configurable: true, get: function () {
    return this.maxFileSize_xomrss$_0.getValue_fmbzy8$(this, UploadInput$maxFileSize_metadata);
  }, set: function (maxFileSize) {
    this.maxFileSize_xomrss$_0.setValue_19qrsr$(this, UploadInput$maxFileSize_metadata, maxFileSize);
  }});
  var UploadInput$minFileSize_metadata = new PropertyMetadata('minFileSize');
  Object.defineProperty(UploadInput.prototype, 'minFileSize', {configurable: true, get: function () {
    return this.minFileSize_pu66ay$_0.getValue_fmbzy8$(this, UploadInput$minFileSize_metadata);
  }, set: function (minFileSize) {
    this.minFileSize_pu66ay$_0.setValue_19qrsr$(this, UploadInput$minFileSize_metadata, minFileSize);
  }});
  var UploadInput$ajaxSettings_metadata = new PropertyMetadata('ajaxSettings');
  Object.defineProperty(UploadInput.prototype, 'ajaxSettings', {configurable: true, get: function () {
    return this.ajaxSettings_wt1ouk$_0.getValue_fmbzy8$(this, UploadInput$ajaxSettings_metadata);
  }, set: function (ajaxSettings) {
    this.ajaxSettings_wt1ouk$_0.setValue_19qrsr$(this, UploadInput$ajaxSettings_metadata, ajaxSettings);
  }});
  var UploadInput$placeholder_metadata = new PropertyMetadata('placeholder');
  Object.defineProperty(UploadInput.prototype, 'placeholder', {configurable: true, get: function () {
    return this.placeholder_yedf3m$_0.getValue_fmbzy8$(this, UploadInput$placeholder_metadata);
  }, set: function (placeholder) {
    this.placeholder_yedf3m$_0.setValue_19qrsr$(this, UploadInput$placeholder_metadata, placeholder);
  }});
  var UploadInput$name_metadata = new PropertyMetadata('name');
  Object.defineProperty(UploadInput.prototype, 'name', {configurable: true, get: function () {
    return this.name_vbbspo$_0.getValue_fmbzy8$(this, UploadInput$name_metadata);
  }, set: function (name) {
    this.name_vbbspo$_0.setValue_19qrsr$(this, UploadInput$name_metadata, name);
  }});
  var UploadInput$disabled_metadata = new PropertyMetadata('disabled');
  Object.defineProperty(UploadInput.prototype, 'disabled', {configurable: true, get: function () {
    return this.disabled_vepl65$_0.getValue_fmbzy8$(this, UploadInput$disabled_metadata);
  }, set: function (disabled) {
    this.disabled_vepl65$_0.setValue_19qrsr$(this, UploadInput$disabled_metadata, disabled);
  }});
  var UploadInput$size_metadata = new PropertyMetadata('size');
  Object.defineProperty(UploadInput.prototype, 'size', {configurable: true, get: function () {
    return this.size_v8fg7m$_0.getValue_fmbzy8$(this, UploadInput$size_metadata);
  }, set: function (size) {
    this.size_v8fg7m$_0.setValue_19qrsr$(this, UploadInput$size_metadata, size);
  }});
  var UploadInput$validationStatus_metadata = new PropertyMetadata('validationStatus');
  Object.defineProperty(UploadInput.prototype, 'validationStatus', {configurable: true, get: function () {
    return this.validationStatus_9cr31g$_0.getValue_fmbzy8$(this, UploadInput$validationStatus_metadata);
  }, set: function (validationStatus) {
    this.validationStatus_9cr31g$_0.setValue_19qrsr$(this, UploadInput$validationStatus_metadata, validationStatus);
  }});
  UploadInput.prototype.render = function () {
    return h('span', this.getSnOptContents(), [this.render_61zpoe$('input')]);
  };
  UploadInput.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    Widget.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_vqcfem$(this.validationStatus);
    classSetBuilder.add_vqcfem$(this.size);
  };
  UploadInput.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$;
    Widget.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    attributeSetBuilder.add_puj7f4$('type', 'file');
    if ((tmp$ = this.name) != null) {
      attributeSetBuilder.add_puj7f4$('name', tmp$);
    }if (this.multiple) {
      attributeSetBuilder.add_puj7f4$('multiple', 'true');
    }if (this.disabled) {
      attributeSetBuilder.add_puj7f4$('disabled');
    }};
  UploadInput.prototype.getValue_dtueoc$_0 = function () {
    var tmp$;
    var v = (tmp$ = this.getFiles_la6brm$_0()) != null ? tmp$ : this.tmpValue;
    return v == null || v.isEmpty() ? null : v;
  };
  function UploadInput$afterInsert$lambda(this$UploadInput) {
    return function (f, f_0) {
      var tmp$, tmp$_0, tmp$_1, tmp$_2;
      return (tmp$_2 = (tmp$_1 = (tmp$_0 = (tmp$ = getElementJQuery(this$UploadInput)) != null ? tmp$.parent() : null) != null ? tmp$_0.parent() : null) != null ? tmp$_1.parent() : null) != null ? tmp$_2.addClass('kv-focus') : null;
    };
  }
  function UploadInput$afterInsert$lambda_0(this$UploadInput) {
    return function (f, f_0) {
      var tmp$, tmp$_0, tmp$_1, tmp$_2;
      return (tmp$_2 = (tmp$_1 = (tmp$_0 = (tmp$ = getElementJQuery(this$UploadInput)) != null ? tmp$.parent() : null) != null ? tmp$_0.parent() : null) != null ? tmp$_1.parent() : null) != null ? tmp$_2.removeClass('kv-focus') : null;
    };
  }
  UploadInput.prototype.afterInsert_77isfd$ = function (node) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6, tmp$_7, tmp$_8, tmp$_9, tmp$_10, tmp$_11, tmp$_12, tmp$_13, tmp$_14, tmp$_15, tmp$_16, tmp$_17, tmp$_18, tmp$_19, tmp$_20, tmp$_21;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.fileinput(this.getSettingsObj_vrl4hd$_0()) : null;
    (tmp$_4 = (tmp$_3 = (tmp$_2 = (tmp$_1 = (tmp$_0 = getElementJQuery(this)) != null ? tmp$_0.parent() : null) != null ? tmp$_1.parent() : null) != null ? tmp$_2.parent() : null) != null ? tmp$_3.find('div.kv-fileinput-caption') : null) != null ? tmp$_4.removeAttr('tabindex') : null;
    (tmp$_9 = (tmp$_8 = (tmp$_7 = (tmp$_6 = (tmp$_5 = getElementJQuery(this)) != null ? tmp$_5.parent() : null) != null ? tmp$_6.parent() : null) != null ? tmp$_7.parent() : null) != null ? tmp$_8.find('input.file-caption-name') : null) != null ? tmp$_9.attr('tabindex', '-1') : null;
    (tmp$_14 = (tmp$_13 = (tmp$_12 = (tmp$_11 = (tmp$_10 = getElementJQuery(this)) != null ? tmp$_10.parent() : null) != null ? tmp$_11.parent() : null) != null ? tmp$_12.parent() : null) != null ? tmp$_13.find('button.fileinput-remove') : null) != null ? tmp$_14.removeAttr('tabindex') : null;
    (tmp$_19 = (tmp$_18 = (tmp$_17 = (tmp$_16 = (tmp$_15 = getElementJQuery(this)) != null ? tmp$_15.parent() : null) != null ? tmp$_16.parent() : null) != null ? tmp$_17.parent() : null) != null ? tmp$_18.find('div.btn-file') : null) != null ? tmp$_19.removeAttr('tabindex') : null;
    (tmp$_20 = getElementJQuery(this)) != null ? tmp$_20.on('focus', UploadInput$afterInsert$lambda(this)) : null;
    (tmp$_21 = getElementJQuery(this)) != null ? tmp$_21.on('blur', UploadInput$afterInsert$lambda_0(this)) : null;
  };
  UploadInput.prototype.bindAllJQueryListeners = function () {
    bindAllJQueryListeners(this, this.jqueryListenersMap);
  };
  UploadInput.prototype.removeAllJQueryListeners = function () {
    removeAllJQueryListeners(this, this.jqueryListenersMap);
  };
  UploadInput.prototype.afterDestroy = function () {
    var tmp$;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.fileinput('destroy') : null;
  };
  UploadInput.prototype.refreshUploadInput_tlfo2p$_0 = function () {
    var tmp$;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.fileinput('refresh', this.getSettingsObj_vrl4hd$_0()) : null;
  };
  UploadInput.prototype.resetInput = function () {
    var tmp$;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.fileinput('reset') : null;
  };
  UploadInput.prototype.clearInput = function () {
    var tmp$;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.fileinput('clear') : null;
  };
  UploadInput.prototype.upload = function () {
    var tmp$;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.fileinput('upload') : null;
  };
  UploadInput.prototype.cancel = function () {
    var tmp$;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.fileinput('cancel') : null;
  };
  UploadInput.prototype.lock = function () {
    var tmp$;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.fileinput('lock') : null;
  };
  UploadInput.prototype.unlock = function () {
    var tmp$;
    (tmp$ = getElementJQueryD(this)) != null ? tmp$.fileinput('unlock') : null;
  };
  UploadInput.prototype.getNativeFile_ghgd4h$ = function (kFile) {
    return this.nativeFiles_ptdivv$_0.get_11rb$(kFile);
  };
  UploadInput.prototype.getFiles_la6brm$_0 = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    this.nativeFiles_ptdivv$_0.clear();
    var fileStack = (tmp$ = getElementJQueryD(this)) != null ? tmp$.fileinput('getFileStack') : null;
    if (fileStack != null) {
      var list = ArrayList_init();
      tmp$_0 = iterator(Object.keys(fileStack));
      while (tmp$_0.hasNext()) {
        var key = tmp$_0.next();
        var nativeFile = Kotlin.isType(tmp$_1 = fileStack[key].file, File) ? tmp$_1 : throwCCE();
        var kFile = new KFile(nativeFile.name, numberToInt(nativeFile.size), null);
        this.nativeFiles_ptdivv$_0.put_xwzc9p$(kFile, nativeFile);
        list.add_11rb$(kFile);
      }
      tmp$_2 = list;
    } else {
      tmp$_2 = null;
    }
    return tmp$_2;
  };
  function UploadInput$getValueAsString$lambda(it) {
    return it.name;
  }
  UploadInput.prototype.getValueAsString = function () {
    var tmp$;
    return (tmp$ = this.value) != null ? joinToString(tmp$, ',', void 0, void 0, void 0, void 0, UploadInput$getValueAsString$lambda) : null;
  };
  UploadInput.prototype.getSettingsObj_vrl4hd$_0 = function () {
    var language = i18n.I18n.language;
    var $receiver = new Object_init();
    var tmp$, tmp$_0, tmp$_1;
    $receiver.uploadUrl = this.uploadUrl;
    $receiver.uploadExtraData = (tmp$ = this.uploadExtraData) != null ? tmp$ : undefined;
    $receiver.theme = this.explorerTheme ? 'explorer-fa6' : 'fa6';
    $receiver.required = this.required;
    $receiver.showCaption = this.showCaption;
    $receiver.showPreview = this.showPreview;
    $receiver.showRemove = this.showRemove;
    $receiver.showUpload = this.showUpload;
    $receiver.showCancel = this.showCancel;
    $receiver.showBrowse = this.showBrowse;
    $receiver.browseOnZoneClick = this.browseOnZoneClick;
    $receiver.preferIconicPreview = this.preferIconicPreview;
    $receiver.allowedFileTypes = (tmp$_0 = this.allowedFileTypes) != null ? copyToArray(tmp$_0) : null;
    $receiver.allowedFileExtensions = (tmp$_1 = this.allowedFileExtensions) != null ? copyToArray(tmp$_1) : null;
    $receiver.dropZoneEnabled = this.dropZoneEnabled;
    var $receiver_0 = new Object_init();
    $receiver_0.showUpload = this.showUpload;
    $receiver_0.showRemove = this.showRemove;
    $receiver.fileActionSettings = $receiver_0;
    $receiver.autoOrientImage = false;
    $receiver.purifyHtml = false;
    if (this.placeholder != null)
      $receiver.msgPlaceholder = this.placeholder;
    $receiver.language = language;
    $receiver.hideThumbnailContent = this.hideThumbnailContent;
    $receiver.showUploadStats = this.showUploadStats;
    $receiver.uploadAsync = this.uploadAsync;
    if (this.maxFileSize != null)
      $receiver.maxFileSize = this.maxFileSize;
    if (this.minFileSize != null)
      $receiver.minFileSize = this.minFileSize;
    if (this.ajaxSettings != null)
      $receiver.ajaxSettings = this.ajaxSettings;
    return $receiver;
  };
  UploadInput.prototype.getState = function () {
    return this.value;
  };
  function UploadInput$subscribe$lambda(this$UploadInput, closure$observer) {
    return function () {
      var $receiver = this$UploadInput.observers;
      var element = closure$observer;
      $receiver.remove_11rb$(element);
      return Unit;
    };
  }
  UploadInput.prototype.subscribe_qlkmfe$ = function (observer) {
    this.observers.add_11rb$(observer);
    observer(this.value);
    return UploadInput$subscribe$lambda(this, observer);
  };
  UploadInput.prototype.setState_11rb$ = function (state) {
    this.value = state;
  };
  function UploadInput$Companion() {
    UploadInput$Companion_instance = this;
    BootstrapUploadModule_getInstance().initialize();
  }
  UploadInput$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var UploadInput$Companion_instance = null;
  function UploadInput$Companion_getInstance() {
    if (UploadInput$Companion_instance === null) {
      new UploadInput$Companion();
    }return UploadInput$Companion_instance;
  }
  function UploadInput$uploadUrl$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$multiple$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refresh();
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$uploadExtraData$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$explorerTheme$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$required$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$showCaption$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$showPreview$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$showRemove$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$showUpload$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$showCancel$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$showBrowse$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$browseOnZoneClick$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$preferIconicPreview$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$allowedFileTypes$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$allowedFileExtensions$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$dropZoneEnabled$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$hideThumbnailContent$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$showUploadStats$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$uploadAsync$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$maxFileSize$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$minFileSize$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$ajaxSettings$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$placeholder$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  function UploadInput$disabled$lambda(this$UploadInput) {
    return function (it) {
      this$UploadInput.refresh();
      this$UploadInput.refreshUploadInput_tlfo2p$_0();
      return Unit;
    };
  }
  UploadInput.$metadata$ = {kind: Kind_CLASS, simpleName: 'UploadInput', interfaces: [MutableState, FormInput, GenericFormComponent, Widget]};
  function suspendCancellableCoroutine$lambda(closure$block) {
    return function (uCont) {
      var cancellable = new CancellableContinuationImpl_init(intercepted(uCont), 1);
      cancellable.initCancellability();
      closure$block(cancellable);
      return cancellable.getResult();
    };
  }
  function getContent$lambda$lambda(closure$cont, closure$reader) {
    return function (it) {
      var $receiver = closure$cont;
      var value = closure$reader.result;
      $receiver.resumeWith_tl1gpc$(new Result(value));
      return Unit;
    };
  }
  function getContent$lambda$lambda_0(closure$cont) {
    return function (e) {
      var $receiver = closure$cont;
      var exception = Exception_init(e.type);
      $receiver.resumeWith_tl1gpc$(new Result(createFailure(exception)));
      return Unit;
    };
  }
  function getContent$lambda(this$getContent) {
    return function (cont) {
      var reader = new FileReader();
      reader.onload = getContent$lambda$lambda(cont, reader);
      reader.onerror = getContent$lambda$lambda_0(cont);
      reader.readAsDataURL(this$getContent);
      return Unit;
    };
  }
  function Coroutine$getContent_1($receiver_0, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.exceptionState_0 = 1;
    this.local$$receiver = $receiver_0;
  }
  Coroutine$getContent_1.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$getContent_1.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$getContent_1.prototype.constructor = Coroutine$getContent_1;
  Coroutine$getContent_1.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            this.state_0 = 2;
            this.result_0 = suspendCancellableCoroutine$lambda(getContent$lambda(this.local$$receiver))(this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 1:
            throw this.exception_0;
          case 2:
            this.result_0;
            return this.result_0;
          default:this.state_0 = 1;
            throw new Error('State Machine Unreachable execution');
        }
      } catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        } else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  function getContent_1($receiver_0, continuation_0, suspended) {
    var instance = new Coroutine$getContent_1($receiver_0, continuation_0);
    if (suspended)
      return instance;
    else
      return instance.doResume(null);
  }
  function getDataWithFileContent$lambda(it) {
    return null;
  }
  function Coroutine$getDataWithFileContent($receiver_0, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.exceptionState_0 = 1;
    this.local$destination = void 0;
    this.local$tmp$ = void 0;
    this.local$tmp$_0 = void 0;
    this.local$tmp$_1 = void 0;
    this.local$valueTransform$result = void 0;
    this.local$value = void 0;
    this.local$tmp$_2 = void 0;
    this.local$destination_0 = void 0;
    this.local$tmp$_3 = void 0;
    this.local$item = void 0;
    this.local$tmp$_4 = void 0;
    this.local$$receiver = $receiver_0;
  }
  Coroutine$getDataWithFileContent.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$getDataWithFileContent.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$getDataWithFileContent.prototype.constructor = Coroutine$getDataWithFileContent;
  Coroutine$getDataWithFileContent.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            var tmp$, tmp$_0;
            var $receiver = this.local$$receiver.fields.entries;
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault($receiver, 10)), 16);
            this.local$destination = LinkedHashMap_init_0(capacity);
            this.local$tmp$ = $receiver.iterator();
            this.state_0 = 2;
            continue;
          case 1:
            throw this.exception_0;
          case 2:
            if (!this.local$tmp$.hasNext()) {
              this.state_0 = 9;
              continue;
            }
            var element = this.local$tmp$.next();
            this.local$tmp$_0 = this.local$destination.put_xwzc9p$;
            this.local$tmp$_1 = element.key;
            var tmp$_1;
            this.local$value = element.value;
            if (Kotlin.isType(this.local$value, KFilesFormControl)) {
              if ((tmp$_1 = this.local$value.getValue()) != null) {
                this.local$destination_0 = ArrayList_init_0(collectionSizeOrDefault(tmp$_1, 10));
                this.local$tmp$_3 = tmp$_1.iterator();
                this.state_0 = 3;
                continue;
              } else {
                this.local$tmp$_2 = null;
                this.state_0 = 7;
                continue;
              }
            } else {
              this.local$valueTransform$result = this.local$value.getValue();
              this.state_0 = 8;
              continue;
            }

          case 3:
            if (!this.local$tmp$_3.hasNext()) {
              this.state_0 = 6;
              continue;
            }
            this.local$item = this.local$tmp$_3.next();
            this.local$tmp$_4 = this.local$destination_0.add_11rb$;
            var tmp$_2;
            if ((tmp$_2 = this.local$value.getNativeFile_ghgd4h$(this.local$item)) != null) {
              this.state_0 = 4;
              this.result_0 = getContent_1(tmp$_2, this);
              if (this.result_0 === COROUTINE_SUSPENDED)
                return COROUTINE_SUSPENDED;
              continue;
            } else {
              this.result_0 = null;
              this.state_0 = 5;
              continue;
            }

          case 4:
            this.state_0 = 5;
            continue;
          case 5:
            this.local$tmp$_4.call(this.local$destination_0, this.local$item.copy_zeh6sj$(void 0, void 0, this.result_0));
            this.state_0 = 3;
            continue;
          case 6:
            this.local$tmp$_2 = this.local$destination_0;
            this.state_0 = 7;
            continue;
          case 7:
            this.local$valueTransform$result = this.local$tmp$_2;
            this.state_0 = 8;
            continue;
          case 8:
            this.local$tmp$_0.call(this.local$destination, this.local$tmp$_1, this.local$valueTransform$result);
            this.state_0 = 2;
            continue;
          case 9:
            var map = this.local$destination;
            tmp$_0 = (tmp$ = this.local$$receiver.modelFactory) != null ? tmp$(withDefault(map, getDataWithFileContent$lambda)) : null;
            if (tmp$_0 == null) {
              throw IllegalStateException_init('Serializer not defined');
            }
            return tmp$_0;
          default:this.state_0 = 1;
            throw new Error('State Machine Unreachable execution');
        }
      } catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        } else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  function getDataWithFileContent($receiver_0, continuation_0, suspended) {
    var instance = new Coroutine$getDataWithFileContent($receiver_0, continuation_0);
    if (suspended)
      return instance;
    else
      return instance.doResume(null);
  }
  function getDataWithFileContent_0($receiver, continuation) {
    return getDataWithFileContent($receiver.form, continuation);
  }
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  Object.defineProperty(package$kvision, 'BootstrapUploadModule', {get: BootstrapUploadModule_getInstance});
  Object.defineProperty(Upload, 'Companion', {get: Upload$Companion_getInstance});
  var package$form = package$kvision.form || (package$kvision.form = {});
  var package$upload = package$form.upload || (package$form.upload = {});
  package$upload.Upload = Upload;
  $$importsForInline$$['kvision-js-legacy'] = $module$kvision_js_legacy;
  Object.defineProperty(UploadInput, 'Companion', {get: UploadInput$Companion_getInstance});
  package$upload.UploadInput = UploadInput;
  $$importsForInline$$['kotlinx-coroutines-core'] = $module$kotlinx_coroutines_core;
  var package$utils = package$kvision.utils || (package$kvision.utils = {});
  package$utils.getContent_fu744r$ = getContent_1;
  package$utils.getDataWithFileContent_58s5v7$ = getDataWithFileContent;
  package$utils.getDataWithFileContent_qr2y4l$ = getDataWithFileContent_0;
  Object.defineProperty(Upload.prototype, 'disabled', Object.getOwnPropertyDescriptor(KFilesFormControl.prototype, 'disabled'));
  Object.defineProperty(Upload.prototype, 'name', Object.getOwnPropertyDescriptor(KFilesFormControl.prototype, 'name'));
  Object.defineProperty(Upload.prototype, 'size', Object.getOwnPropertyDescriptor(KFilesFormControl.prototype, 'size'));
  Object.defineProperty(Upload.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(KFilesFormControl.prototype, 'validationStatus'));
  Object.defineProperty(Upload.prototype, 'validatorError', Object.getOwnPropertyDescriptor(KFilesFormControl.prototype, 'validatorError'));
  Upload.prototype.getValue = KFilesFormControl.prototype.getValue;
  Upload.prototype.setValue_s8jyv4$ = KFilesFormControl.prototype.setValue_s8jyv4$;
  Upload.prototype.styleForHorizontalFormPanel_fn6884$ = KFilesFormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  Upload.prototype.styleForInlineFormPanel = KFilesFormControl.prototype.styleForInlineFormPanel;
  Upload.prototype.styleForVerticalFormPanel = KFilesFormControl.prototype.styleForVerticalFormPanel;
  return _;
}));

//# sourceMappingURL=kvision-kvision-bootstrap-upload-js-legacy.js.map
